export const map = {
  mode: "zh",
  map: {
    adressTitle: "地址",
    adress: "首尔市江南大路364MEEWANG大厦1709",
    studioTitle: "SEL-DI影棚",
    studioAdress: "首尔市江南大路116街B1SEL-DI影棚",
  },
};
